import { lazy } from "react";

export const UGCProductionPage = lazy(() =>
  import("./UGCProductionPage.jsx").then((module) => ({
    default: module.default,
  }))
);
